<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        List of Document(s)
      </div>
      <v-spacer> </v-spacer>

      <v-btn
        small
        color="primary"
        class="mr-6"
        v-if="checkPermission('app_logistics:logistics_doc_upload')"
        @click="$router.push('/doc-details/0')"
        >Add Document</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="_headers"
      :items="list"
      :loading="listLoader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-form>
          <v-row class="custom-row pl-5 pr-5 mb-1">
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="doc_title"
                hide-no-data
                outlined
                label="Doc Title"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="doc_type"
                label="Doc Type"
                item-text="text"
                item-value="value"
                :items="docsType"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
              <v-select
                v-model="user_category"
                label="User Category"
                item-text="value"
                item-value="id"
                :items="userTypes"
                outlined
                @change="getserviceType"
              ></v-select>
            </v-col>
            <v-col v-if="user_category === 1" cols="12" sm="3">
              <v-autocomplete
                v-model="client_service_type"
                :items="services"
                :loading="clientLoader"
                hide-no-data
                item-text="name"
                item-value="id"
                outlined
                label="Client Service Type"
                placeholder="Start typing to Search"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
              <v-autocomplete
                v-model="status"
                :items="statuses"
                hide-no-data
                outlined
                label="Status"
                placeholder="Start typing to Search"
              ></v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              sm="3"
              :class="[
                userCategory.user_category === 1
                  ? 'offset-md-3'
                  : 'offset-md-9',
              ]"
            >
              <v-btn color="white" @click="clearAll" style="float: right"
                >Clear</v-btn
              >
              <v-btn
                color="primary"
                class="success mr-5"
                @click="searchAll"
                style="float: right"
                >Search</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="mb-5"></v-divider>
      </template>
      <template v-slot:[`item.doc_file`]="{ item }">
        <v-list v-if="item.doc_file" dense>
          <ul v-for="(file, index) in item.doc_file" :key="index">
            <li v-if="file">
              <a @click="open(file)">{{ file }}</a>
            </li>
          </ul>
        </v-list>
        <span v-else>--</span>
      </template>
      <template v-slot:item.doc_status="{ item }">
        <v-chip class="ma-1" :color="item.doc_status ? 'success' : 'error'">
          {{ item.doc_status ? "Active" : "Inactive" }}
        </v-chip>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">
          {{ item.created_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A") }}
          {{ item.created_by }}</span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.modified_at`]="{ item }">
        <span v-if="item.modified_at">
          {{ item.modified_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A") }}
          {{ item.modified_by }}</span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.modified_at">
          {{ item.modified_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A") }}
        </span>
        <span v-else>--</span>
      </template>

      <template v-slot:[`item.client_service_type`]="{ item }">
        <span v-if="item.client_service_type">
          {{ item.client_service_type }}
        </span>
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.user_category_name`]="{ item }">
        <span v-if="item.user_category_name">
          {{ item.user_category_name }}
          <span v-if="item.rsa_client">({{ item.rsa_client }})</span></span
        >
        <span v-else>--</span>
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              v-if="checkPermission('app_logistics:logistics_doc_update')"
              @click="edit(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userCategory", "userTypes"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "modified_at" &&
              i.value !== "created_at" &&
              i.value !== "doc_status" &&
              i.value !== "action"
          : i.value !== "updated_at";
      });
    },
  },
  data: () => ({
    optionsDetails: {
      page: 1,
      itemsPerPage: 25,
      sortDesc: [false],
    },
    user_category: "",
    client_service_type: "",
    doc_type: "",
    doc_title: "",
    status: "",
    listloader: false,
    statuses: [
      { text: "Active", value: "True" },
      { text: "Inactive", value: "False" },
    ],
    docsType: [
      "Last Mile SOP",
      "Prohibited and Restricted Item List",
      "Customs De Miniums",
      "Customer Rate Card",
      "Customs Related Charges",
    ],
    headers: [
      {
        text: "Doc Title",
        value: "doc_title",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Doc Description",
        value: "doc_desc",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Doc Type",
        value: "doc_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "User Category",
        value: "user_category_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Client Service",
        value: "client_service_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Files",
        value: "doc_file",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "100px",
      },

      {
        text: "Status",
        value: "doc_status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Created At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        width: "120px",
        sortable: false,
      },
      {
        text: "Updated At (By)",
        value: "modified_at",
        class: "body-1 font-weight-bold",
        width: "120px",
        sortable: false,
      },
      {
        text: "Updated At",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        width: "120px",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        width: "50px",
        sortable: false,
      },
    ],
    carriers: [],
    isTableloading: false,
    itemCalled: false,
    sku: null,
    client: null,
    loading: false,
    list: [],
    listLoader: false,
    filtersArr: {},
    clients: [],
    total: 0,
    options: {},
    services: [],
  }),

  created() {
    // this.fetchClientList();
    this.getUserTypes();

    if (this.userCategory.user_category == 1) {
      this.fetchVendor();
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
    optionsDetails: {
      handler() {},
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "fetchClient",
      "getDocumentList",
      "getUserTypes",
      "getTypeClients",
      "downloadPasTemplate",
    ]),
    getserviceType() {
      if (this.user_category == 1)
        this.getTypeClients().then((res) => {
          this.services = res.data;
        });
    },

    open(path) {
      this.downloader = true;
      const parts = path.split("/");
      // The file name is the last part of the URL
      const fileName = parts[parts.length - 1];
      let url = `api/file_download?file_path=documents/doc_files/${fileName}`;

      this.downloadPasTemplate(url)
        .then((res) => {
          this.fileDownload(res, "pdf");
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },

    edit(item) {
      this.$router.push({ name: "AddServieCenter", params: { id: item.id } });
    },

    clearAll() {
      this.filtersArr = {};
      this.user_category = "";
      this.client_service_type = "";
      this.doc_type = "";
      this.doc_title = "";
      this.status = "";
      this.fetchList();
    },

    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "fulfillment,fulfillment_wid_last_mile",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    allFilters() {
      this.clientsLoader = true;
      let obj = {
        doc_type: this.doc_type,
        doc_title: this.doc_title,
        status: this.status,
        user_category: this.user_category,
        client_service_type: this.client_service_type,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    listPage() {
      this.$router.push({
        name: "skuStatusList",
        params: {
          type: "sku_mapping",
        },
      });
    },

    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getDocumentList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    fetchList() {
      this.list = [];
      this.listLoader = true;
      this.getDocumentList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
  },
};
</script>
<style>
.custom-row .col-sm-2 {
  flex: 1 0 16.6666666667% !important;
  max-width: 21.666667% !important;
}
/* Styles for the loader wrapper */
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure the loader appears on top of other content */
}

/* Styles for the loader itself */
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite; /* Add a spinning animation */
}

/* Animation keyframes for the loader */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Styles to hide the content when the loader is active */
.loader-wrapper.active {
  display: flex;
}

.content {
  display: none;
}

.loader-wrapper.active + .content {
  display: block;
}
.v-data-table.elevation-1.custom-padding.theme--light tbody tr td.text-start {
  padding: 0 !important;
}
.spanClass {
  display: block;
  padding-left: 18px;
  padding-top: 6px;
}
</style>
